import { useObserver } from "mobx-react";
import { AiOutlineCaretDown, AiOutlineCaretUp } from "react-icons/ai";

export default function NumberSelector(props) {
  return useObserver(() => (
    <div className="flex  gap-1 text-lg border justify-between  overflow-hidden items-center my-4 rounded-lg bg-white border-[#cbc9c9]  px-4 h-10">
      <label className="font-medium text-base w-20">{props.label}</label>
      <input
        type="text"
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        value={props.value}
        required
        readOnly
        min={5}
        onChange={(e) => {
          if (props.regex && props.regexFormula instanceof RegExp) {
            // Check if regexFormula is RegExp
            if (!props.regexFormula.test(e.target.value)) {
              e.target.value = e.target.value.slice(0, -1); // Remove last character if invalid
            } else {
              props.action(e.target.value); // Only call action if regex matches
            }
          } else {
            props.action(e.target.value);
          }
        }}
        className=" px-4 rounded-lg w-20 text-center focus:outline-none text-primary appearance-none hide-arrows  h-10 "
      />
      <span className="flex flex-col -gap-2">
        <AiOutlineCaretUp
          className="text-xs text-primary"
          onClick={() => {
            const n = Number(props.value);
            const current = Number.isFinite(n) ? n : 0;
            props.action(current + 1);
          }}
        ></AiOutlineCaretUp>
        <AiOutlineCaretDown
          className="text-xs text-primary"
          onClick={() => {
            const n = Number(props.value);
            const current = Number.isFinite(n) ? n : 0;
            props.action(Math.max(0, current - 1));
          }}
        ></AiOutlineCaretDown>
      </span>
    </div>
  ));
}
